import React, { useContext } from "react";
import { connect } from "react-redux";
import { CheckboxTable } from "../../view/CheckboxTable";
import { TableContext } from "../../index";
import DeviceAuthorizationTableRow from "./DeviceAuthorizationTableRow";

function DeviceAuthorizationTable({ authorizations = [], onEdit }) {
    const { config } = useContext(TableContext);
    const term = (config.searchTerm || "").toLowerCase();
    const filtered = term
        ? authorizations.filter(item =>
            (item.deviceName || item.device || "").toLowerCase().includes(term)
            || (item.username || "").toLowerCase().includes(term)
            || (item.action || "").toLowerCase().includes(term)
            || (item.authorization || "").toLowerCase().includes(term))
        : authorizations;
    const pageSize = config.pageSize || filtered.length || 1;
    const pageNumber = config.pageNumber || 0;
    const paged = config.localPagination
        ? filtered.slice(pageNumber * pageSize, pageNumber * pageSize + pageSize)
        : filtered;

    const headers = [
        { name: "DEVICE", sortKey: "devicePk" },
        { name: "USER", sortKey: "username" },
        { name: "ACTION", sortKey: "action" },
        { name: "AUTHORIZATION", sortKey: "authorization" },
        { name: "ALERT" }
    ];

    return (
        <>
            <CheckboxTable className="mt-4" headers={headers} elements={paged}>
                {paged.map((item, index) => (
                    <DeviceAuthorizationTableRow key={item.id || index}
                        data={item}
                        index={index}
                        onEdit={onEdit} />
                ))}
            </CheckboxTable>
            {paged.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    );
}

function mapStateToProps(state) {
    return {
        authorizations: state.deviceAuthorizationPage?.authorizations || []
    };
}

export default connect(mapStateToProps)(DeviceAuthorizationTable);
